import React from 'react';
import './Popup.css';

const Popup = ({
    isOpen,
    setIsOpen,
    title = '',
    description = '',
    buttonText = '',
    buttonOnClick = () => { },
}) => {
    if (!isOpen) return null;

    const handleClose = () => {
        setIsOpen(false);
    };

    return (
        <div className="popup-overlay" onClick={handleClose}>
            <div className="popup-content" onClick={(e) => e.stopPropagation()}>
                <h2>{title}</h2>
                <p>{description.split('\n').map((line, index) => (
                    <React.Fragment key={index}>
                        {line}
                        <br />
                    </React.Fragment>
                ))}</p>
                <button onClick={buttonOnClick} className="unlock-button">
                    {buttonText}
                </button>
                <button onClick={handleClose} className="close-button">
                    ×
                </button>
            </div>
        </div>
    );
};

export default Popup;
